// FORCE UPDATE v7
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/analytics';
import { auth } from '../services/firebase';

export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      
      // Disparar PageView híbrido para GTM e Meta CAPI
      const currentUser = auth.currentUser;
      trackEvent('PageView', currentUser ? {
        email: currentUser.email || undefined,
        first_name: currentUser.displayName || undefined,
        external_id: currentUser.uid
      } : undefined, {
        page_path: typeof window !== 'undefined' ? (window.location.hash || window.location.pathname) : '',
        page_title: typeof document !== 'undefined' ? document.title : ''
      });
    } catch (e) {
      // Ignora erro em ambientes sem window
    }
  }, [pathname]);

  return null;
};